import { render, staticRenderFns } from "./ProcessExpenses.vue?vue&type=template&id=2ee4d624&"
import script from "./ProcessExpenses.vue?vue&type=script&lang=js&"
export * from "./ProcessExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports